import React from 'react';
import CaseCard from '../cards/CaseCard';
import { cases } from '../../data/cases';
import './Cases.css';

const Cases = () => {
  return (
    <section className="cases">
      <div className="wrap">
        <div className="sechead">
          <span className="kicker">Por setor</span>
          <h2>Ache alguém igual a você</h2>
          <p>
            Indústria, saúde, alimentação, serviços: a metodologia se adapta à
            realidade de cada empresa.
          </p>
        </div>

        {cases.map((sectorData) => (
          <div key={sectorData.id} className="setor">
            <h3>{sectorData.sector}</h3>
            <p className="setor-sub">{sectorData.subtitle}</p>
            <div className="grid">
              {sectorData.items.map((caseItem) => (
                <CaseCard key={caseItem.id} caseItem={caseItem} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Cases;
